import RulesList from "./pages/list/RulesList";
import { ToastProvider } from "../../context/ToastContext";
import { RulesContextProvider } from "../../context/RulesContext";
import ToastContainer from "../../components/Toast/ToastContainer";

const RulesApp = () => {
    return (
        <>
            <ToastProvider>
                <RulesContextProvider>
                    <RulesList />
                    <ToastContainer />
                </RulesContextProvider>
            </ToastProvider>
        </>
    );
};

export default RulesApp;
